import React from 'react';
import { useTranslation } from 'react-i18next';

import { General } from 'icons/untitledui';

import * as Styled from 'shiftNotes/styles/NotesStack.style';

interface NoteCardLoadingSectionProps {
  phase: 'structuring' | 'thinking';
}

export default function NoteCardLoadingSection({
  phase,
}: NoteCardLoadingSectionProps): JSX.Element {
  const { t } = useTranslation('pageShiftNotes');
  const label =
    phase === 'structuring'
      ? t('noteCaptureResponse.structuring')
      : t('instantReflex.loading');

  return (
    <Styled.LoadingPill role="status" aria-live="polite">
      <Styled.LoadingPillIcon aria-hidden="true">
        <General.Loading02 />
      </Styled.LoadingPillIcon>
      <Styled.LoadingPillLabel>{label}</Styled.LoadingPillLabel>
    </Styled.LoadingPill>
  );
}
